import BodyLayout from "../../layouts/BodyLayout";
import Title from "../Title";
import { Stack, Typography, Button } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { useState } from "react";

type MagazineItem = {
    name: string;
    link: string;
};

type MagazinesData = {
    [year: string]: MagazineItem[];
};

type Props = {};

const Magzine = (props: Props) => {
    const years: string[] = ["2024-25", "2023-24"];

    const magazines: MagazinesData = {
        "2024-25": [
            {
                name: "College Annual Magazine 2024-25",
                link: "/assets/pdf/download/Magzines/St Xavier's Magazine 25-26.pdf"
            }
        ],

        "2023-24": [],
    };

    const [selectedYear, setSelectedYear] = useState<string>(years[0]);

    return (
        <BodyLayout>
            <Title title="Annual Magazines" />

            {/* Year Selector */}
            <Stack direction="row" spacing={2} mt={5} mb={3}>
                {years.map((year) => (
                    <Button
                        key={year}
                        variant={selectedYear === year ? "contained" : "outlined"}
                        color="primary"
                        size="small"
                        sx={{ textTransform: "none" }}
                        onClick={() => setSelectedYear(year)}
                    >
                        {year}
                    </Button>
                ))}
            </Stack>

            {/* Magazine List for Selected Year */}
            <Stack mb={3}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    {selectedYear}
                </Typography>
                {magazines[selectedYear] && magazines[selectedYear].length > 0 ? (
                    magazines[selectedYear].map((item: MagazineItem, idx: number) => (
                        <Stack
                            key={idx}
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            mb={1}
                            sx={{
                                backgroundColor: "#f9f9f9",
                                padding: "8px 12px",
                                borderRadius: "6px",
                                transition: "all 0.2s ease-in-out",
                                "&:hover": { backgroundColor: "#f1f1f1" },
                            }}
                        >
                            <DescriptionIcon color="action" fontSize="small" />
                            <Typography
                                component="a"
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: "primary.main",
                                    textDecoration: "none",
                                    "&:hover": { textDecoration: "underline" },
                                }}
                            >
                                {item.name}
                            </Typography>
                        </Stack>
                    ))
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        No magazine available for this year.
                    </Typography>
                )}
            </Stack>
        </BodyLayout>
    );
};

export default Magzine;
